import { Client } from '@/utilities/api/Client';
import { PromotionEndpoint, SubwalletEndpoint } from "@api/endpoints";
import { QueryUtil } from "@/utilities/Query";

export class SubwalletApi {
  static create (
    body: SubwalletEndpoint.Create.Request,
  ): Promise<SubwalletEndpoint.Create.Response> {
    return Client(`subwallets`, {
      method: 'POST',
      body,
    });
  }

  static delete (id: string): Promise<void> {
    return Client(`subwallets/${id}`, { method: 'DELETE' });
  }

  static get (id: string): Promise<SubwalletEndpoint.Get.Response> {
    return Client(`subwallets/${id}`);
  }

  static hasPointsHistory (
    subwalletId: string,
    query?: SubwalletEndpoint.HasPointsHistory.Query,
  ):
    Promise<PromotionEndpoint.HasPointsHistory.Response> {
    if (query) {
      return Client(`subwallets/${subwalletId}/has-points-history?${QueryUtil.stringify(query)}`);
    }
    return Client(`subwallets/${subwalletId}/has-points-history`);
  }

  static list (query: SubwalletEndpoint.List.Query): Promise<SubwalletEndpoint.List.Response> {
    if (query.manufacturerId === null) {
      query.manufacturerId = 'null';
    }
    const queryString = QueryUtil.stringify(query);
    return Client(`subwallets?${queryString}`);
  }

  static listProgramYears (
    subwalletId: string,
  ): Promise<SubwalletEndpoint.ListProgramYears.Response> {
    return Client(`subwallets/${subwalletId}/program-years`);
  }

  static listRedeemableProducts (
    subwalletId: string,
    query: SubwalletEndpoint.ListRedeemableProducts.Query,
  ): Promise<SubwalletEndpoint.ListRedeemableProducts.Response> {
    const queryString = QueryUtil.stringify(query);
    return Client(`subwallets/${subwalletId}/redeemable-products?${queryString}`);
  }

  static updateProgramYearLock (
    subwalletId: string,
    rewardsProgramId: string,
    body: SubwalletEndpoint.UpdateProgramYearLock.Request,
  ): Promise<SubwalletEndpoint.UpdateProgramYearLock.Response> {
    return Client(`subwallets/${subwalletId}/program-years/${rewardsProgramId}/lock`, {
      method: 'PATCH',
      body,
    });
  }

  static update (
    id: string,
    body: SubwalletEndpoint.Update.Request,
  ): Promise<SubwalletEndpoint.Update.Response> {
    return Client(`subwallets/${id}`, {
      method: 'PATCH',
      body,
    });
  }
}
